import { render, staticRenderFns } from "./FAhero.vue?vue&type=template&id=47722a8d&scoped=true&"
import script from "./FAhero.vue?vue&type=script&lang=js&"
export * from "./FAhero.vue?vue&type=script&lang=js&"
import style0 from "./FAhero.vue?vue&type=style&index=0&id=47722a8d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47722a8d",
  null
  
)

export default component.exports